
// => Styling
import styles from './TextPrompt.module.css';


// ============
// Component
// ============
const TextPrompt = ({ text = null }) => {


    // RENDER
    // ---------
    return(
        text !== null && (
        <div className={styles.container}>
            {text}
        </div>)
    )
}


export default TextPrompt